import React, { useEffect, useState } from 'react';
import { Module, supabase } from '../../lib/supabase';
import { useAuthStore } from '../../lib/store-auth';
import './module-player.scss';

interface ModuleListProps {
    onStartModule: (mod: Module) => void;
}

export const ModuleList: React.FC<ModuleListProps> = ({ onStartModule }) => {
    const { user } = useAuthStore();
    const [modules, setModules] = useState<Module[]>([]);
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        const fetchModules = async () => {
            if (!supabase || !user?.institution_id) {
                setIsLoading(false);
                return;
            }
            try {
                const { data, error } = await supabase
                    .from('modules')
                    .select('*')
                    .eq('institution_id', user.institution_id)
                    .eq('is_active', true)
                    .order('created_at', { ascending: false });

                if (error) throw error;
                setModules((data || []).map((m: any) => ({ ...m, items: m.items || [] })));
            } catch (err) {
                console.error('Modüller yüklenemedi:', err);
            } finally {
                setIsLoading(false);
            }
        };
        fetchModules();
    }, [user]);

    if (isLoading) {
        return <div className="module-list-empty">Yükleniyor...</div>;
    }

    if (modules.length === 0) {
        return (
            <div className="module-list-empty">
                <span className="material-symbols-outlined">school</span>
                <p>Henüz modül bulunmamaktadır.</p>
            </div>
        );
    }

    return (
        <div className="module-list-grid">
            {modules.map((mod) => {
                const quizCount = mod.items.filter(i => i.type === 'quiz').length;
                const miniSimCount = mod.items.filter(i => i.type === 'mini_sim').length;
                const mainSimCount = mod.items.filter(i => i.type === 'main_sim').length;

                return (
                    <div
                        key={mod.id}
                        className="module-card"
                        onClick={() => onStartModule(mod)}
                    >
                        <div className="module-card-gradient" />

                        <div className="module-card-header">
                            <div className="module-card-icon">
                                <span className="material-symbols-outlined">school</span>
                            </div>
                            <div>
                                <h3 className="module-card-title">{mod.title}</h3>
                                <span className="module-card-steps">{mod.items.length} adım</span>
                            </div>
                        </div>

                        {mod.description && (
                            <p className="module-card-desc">{mod.description}</p>
                        )}

                        <div className="module-card-badges">
                            {quizCount > 0 && (
                                <span className="badge badge-quiz">{quizCount} Soru</span>
                            )}
                            {miniSimCount > 0 && (
                                <span className="badge badge-mini-sim">{miniSimCount} Mini Sim</span>
                            )}
                            {mainSimCount > 0 && (
                                <span className="badge badge-main-sim">{mainSimCount} Ana Sim</span>
                            )}
                        </div>

                        <div className="module-card-action">
                            <span>Başla</span>
                            <span className="material-symbols-outlined">arrow_forward</span>
                        </div>
                    </div>
                );
            })}
        </div>
    );
};
